// --- 系统管理 --- //

export default [
  {
    name: 'sysResourceManagement',
    path: '/systemManagement/:supplyId/resourceManagement/list',
    meta: { title: '资源管理' },
    component: require('business/systemManagement/resourceManagement/list.vue').default
  },
  {
    name: 'sysRoleManagement',
    path: '/systemManagement/:supplyId/roleManagement/list',
    meta: { title: '角色管理' },
    component: require('business/systemManagement/roleManagement/list.vue').default
  },
  {
    name: 'sysUserManagement',
    path: '/systemManagement/:supplyId/sysUserManagement/list',
    meta: { title: '系统用户管理' },
    component: require('business/systemManagement/sysUserManagement/list.vue').default
  }
]
